import React, { useEffect, useState } from 'react'
import { Button, Col, Form, InputGroup, Row } from 'react-bootstrap'
import { createSearchParams } from 'react-router-dom'
import { PaginationControl } from 'react-bootstrap-pagination-control'
import { EMP_CHECK_LIST_NEW } from '../../../router/routes'
import { getChecklistNewAPI } from '../../../services/checklist'
import Error_500 from '../../error/error-500'
import { useSelector } from 'react-redux'
import Error_false from '../../error/error-false'
import { Controller, useForm } from 'react-hook-form'
import NavMenuLayout from './nav-menu'
import { DatePicker } from 'antd'
import { BsArrowClockwise, BsSearch, BsSliders2Vertical } from 'react-icons/bs'
import ModalCustom from '../../modal-custom'
import LabelCustom from '../../label-custom'
import Autocomplete from '../../custom/autocomplete'
import TableListNew from './new/table-list'
import ModalCancel from './new/ModalCancel'
import UseResignOption from '../../../hooks/use-resign-option'
import UseChecklistNewStep from '../../../hooks/use-checklist-new-step'
import UseChecklistStatus from '../../../hooks/use-checklist-status'
import { BODYCLN } from '../../../Constants'
import PickerRangeCustom from '../../datepicker-between-custom'
import dayjs from 'dayjs'
import { fnDateEn } from '../../../helper/fnDateEn'
export default function CheckListNewPage() {
  const {
    control,
    handleSubmit,
    setValue,
    reset,
    formState: { errors }
  } = useForm()
  const orgId = useSelector((state) => state.roleReducer.role)
  const optionStep = UseChecklistNewStep()
  const optionStatus = UseChecklistStatus()
  const bodyQuery = JSON.parse(localStorage.getItem(BODYCLN))
  const [page, setPage] = useState(1)
  const [bodyFilter, setBodyFilter] = useState()
  const [sortDoc, setSortDoc] = useState(false)
  const [sortCode, setSortCode] = useState(false)
  const [sortStartDate, setSortStartDate] = useState(false)
  const [sortName, setSortName] = useState(false)
  const [clickedColumn, setClickedColumn] = useState(null)

  const hadleClick = (d, event) => {
    event.preventDefault()

    const url = `${EMP_CHECK_LIST_NEW}/stap-${
      d.step_id > 2 ? 3 : d.step_id
    }?${createSearchParams({
      code: d.code,
      org: orgId,
      id: d.cln_no,
      stap: d.step_id > 2 ? 3 : d.step_id
    })}`
  }

  const [totalPage, setTotalPages] = useState(0)
  const [totalRows, setTotalRows] = useState(0)
  const [totalLimits, setTotalLimits] = useState(20)
  const [isLoading, setIsLoading] = useState(true)
  const [statusId, setStatusId] = useState(1)
  const [monthYear, setMonthYear] = useState('')

  const [dataChecklist, setDataChecklist] = useState([])

  const resignsOption = UseResignOption()
  const dateFormat = 'MMMM YYYY'
  const [showFilter, setShowFilter] = useState(false)
  const handleClose = () => setShowFilter(false)
  const handleShow = () => setShowFilter(true)

  useEffect(() => {
    if (optionStep.length > 0 && orgId !== '') {
      if (orgId !== bodyQuery?.orgId) {
        const d = {
          page: 1,
          orgId,
          statusId: 1
        }
        setPage(1)
        setStatusId(1)
        getChecklistNew(d)
      } else if (bodyQuery) {
        const stpId = optionStep.find(
          (item) => item.value === bodyQuery?.stepId
        )
        setPage(bodyQuery?.page ?? 1)
        setMonthYear(bodyQuery?.monthYear)
        setValue('stepId', stpId)

        setValue('searchs', bodyQuery?.searchs)
        setValue('startDate', [
          bodyQuery?.startDateFirst ?? '',
          bodyQuery?.startDateLast ?? ''
        ])
        setClickedColumn(bodyQuery.sortBy)
        setSortCode(bodyQuery.order !== 'asc' ? true : false)

        setStatusId(bodyQuery?.statusId ?? '')
        getChecklistNew(bodyQuery)
      }
    }
  }, [optionStep, orgId])

  async function getChecklistNew(body) {
    try {
      if (orgId) {
        const param = {
          ...body,
          orgId
        }
        localStorage.setItem(BODYCLN, JSON.stringify(param))
        setBodyFilter(param)
        setIsLoading(true)
        const resp = await getChecklistNewAPI(param)
        setIsLoading(false)
        if (!resp) return
        if (resp.status) {
          setDataChecklist(resp.result ?? [])
          setTotalPages(resp.totalPages)
          setTotalRows(resp.totalRows)
          setTotalLimits(resp.totalLimits)
        } else {
          Error_false(resp)
          setDataChecklist([])
          setTotalPages(0)
          setTotalRows(0)
          setTotalLimits(20)
        }
      }
    } catch (error) {
      setIsLoading(false)
      Error_500(error)
    }
  }

  const handleSortDoc = (column) => {
    // setClickedColumn(!clickedColumn);
    setClickedColumn(column)

    if (sortDoc) {
      setSortDoc(false)
      getChecklistNew({
        ...bodyFilter,
        page: 1,
        order: 'asc',
        sortBy: 'clnNo'
      })
    } else {
      setSortDoc(true)
      getChecklistNew({
        ...bodyFilter,
        page: 1,
        order: 'desc',
        sortBy: 'clnNo'
      })
    }
    setPage(1)
  }
  const handleSortCode = (column) => {
    setClickedColumn(column)

    if (sortCode) {
      setSortCode(false)
      getChecklistNew({ ...bodyFilter, page: 1, order: 'asc', sortBy: 'code' })
    } else {
      setSortCode(true)
      getChecklistNew({ ...bodyFilter, page: 1, order: 'desc', sortBy: 'code' })
    }
    setPage(1)
  }
  const handleSortStartDate = (column) => {
    setClickedColumn(column)
    if (sortStartDate) {
      setSortStartDate(false)
      getChecklistNew({
        ...bodyFilter,
        page: 1,
        order: 'asc',
        sortBy: 'startDate'
      })
    } else {
      setSortStartDate(true)
      getChecklistNew({
        ...bodyFilter,
        page: 1,
        order: 'desc',
        sortBy: 'startDate'
      })
    }
    setPage(1)
  }
  const handleSortName = (column) => {
    setClickedColumn(column)

    if (sortName) {
      setSortName(false)
      getChecklistNew({ ...bodyFilter, page: 1, order: 'asc', sortBy: 'name' })
    } else {
      setSortName(true)
      getChecklistNew({ ...bodyFilter, page: 1, order: 'desc', sortBy: 'name' })
    }
    setPage(1)
  }

  const onChangeMonth = (date, dateString) => {
    const body = {
      orgId,
      page: 1,
      statusId,
      searchs: bodyFilter.searchs,
      stepId: bodyFilter.stepId ?? '',
      startDateFirst: bodyFilter.startDateFirst ?? '',
      startDateLast: bodyFilter.startDateLast ?? '',
      monthYear: dateString ? fnDateEn(date).format('YYYYMM') : '',
      order: bodyFilter.order,
      sortBy: bodyFilter.order
    }
    setPage(1)
    setMonthYear(body.monthYear)
    getChecklistNew(body)
  }

  const onSubmit = (d) => {
    const body = {
      orgId,
      page: 1,
      searchs: d.searchs,
      stepId: d.stepId?.value ?? '',
      statusId: statusId ?? '',
      monthYear,
      startDateFirst:
        d.startDate && d.startDate.length > 0 ? d.startDate[0] : '',
      startDateLast:
        d.startDate && d.startDate.length > 0 ? d.startDate[1] : '',
      order: bodyFilter.order,
      sortBy: bodyFilter.order
    }

    setPage(1)
    getChecklistNew(body)
    handleClose()
  }

  const onSearch = (d) => {
    const body = {
      orgId,
      page: 1,
      searchs: d.searchs,
      statusId,
      monthYear,
      order: bodyFilter.order,
      sortBy: bodyFilter.order
    }

    setPage(1)
    getChecklistNew(body)
  }

  const [openCancel, setOpenCancel] = useState(false)
  const [detailById, setDetailById] = useState()
  const fnCancelCLN = (data) => {
    setOpenCancel(true)
    setDetailById(data)
  }

  const onCancel = () => setOpenCancel(false)

  const clearSearch = () => {
    reset()
    const body = {
      orgId,
      page: 1,
      statusId: 1,
      monthYear: '',
      order: bodyFilter.order,
      sortBy: bodyFilter.order
    }
    setValue('startDate', ['', ''])
    setMonthYear('')
    setPage(1)
    setStatusId(1)

    getChecklistNew(body)
  }
  return (
    <>
      <div className="p-3 ">
        <Row>
          <ModalCancel
            bodyFilter={bodyFilter}
            fnData={getChecklistNew}
            resignsOption={resignsOption}
            data={detailById}
            open={openCancel}
            onCancel={onCancel}
          />

          <Col xl={12}>
            <div className="d-flex justify-content-between">
              <NavMenuLayout />
              {orgId ? (
                <div className="justify-content-end gap-2 my-auto ps-0 d-flex">
                  <Form onSubmit={handleSubmit(onSearch)}>
                    <Form.Group className="" style={{ minWidth: 300 }}>
                      <Controller
                        name={'searchs'}
                        control={control}
                        render={({ field: { onChange, value = '' } }) => (
                          <InputGroup className="">
                            <InputGroup.Text className="bg-white border-end-0  text-muted">
                              <BsSearch />
                            </InputGroup.Text>
                            <Form.Control
                              value={value}
                              placeholder="Doc No./ Code/ Name/ Nickname"
                              onChange={onChange}
                              className="border-start-0 ps-0 placeholder-text"
                            />
                          </InputGroup>
                        )}
                      />
                    </Form.Group>
                  </Form>

                  <DatePicker
                    style={{ minWidth: '160px' }}
                    value={monthYear ? dayjs(monthYear) : ''}
                    className=""
                    format={dateFormat}
                    picker="month"
                    onChange={onChangeMonth}
                  />

                  <div
                    className=""
                    style={{
                      width: '150px',
                      position: 'sticky',
                      top: 0,
                      zIndex: 999
                    }}
                  >
                    {' '}
                    <Autocomplete
                      options={optionStatus}
                      value={
                        optionStatus.length > 0
                          ? optionStatus.find((item) => item.value === statusId)
                          : ''
                      }
                      onChange={(data) => {
                        setStatusId(data.value)
                        const body = {
                          orgId,
                          page: 1,
                          statusId: data.value,
                          searchs: bodyFilter.searchs,
                          stepId: bodyFilter.stepId ?? '',
                          startDateFirst: bodyFilter.startDateFirst ?? '',
                          startDateLast: bodyFilter.startDateLast ?? '',
                          monthYear,
                          order: bodyFilter?.order ?? '',
                          sortBy: bodyFilter?.order ?? ''
                        }
                        setPage(1)
                        getChecklistNew(body)
                      }}
                    />
                  </div>

                  <Button
                    size="sm"
                    className="text-primary"
                    type="button"
                    variant="light"
                    style={{ minWidth: '100px' }}
                    onClick={handleShow}
                  >
                    <BsSliders2Vertical className="me-2" /> Filter
                  </Button>
                  <Button
                    size="sm"
                    type="button"
                    variant="light"
                    onClick={() => clearSearch()}
                    className="text-primary"
                  >
                    <BsArrowClockwise />
                  </Button>
                </div>
              ) : (
                <></>
              )}
            </div>
          </Col>
        </Row>
      </div>

      <TableListNew
        fnCancelCLN={fnCancelCLN}
        dataChecklist={dataChecklist}
        page={page}
        totalLimits={totalLimits}
        isLoading={isLoading}
        hadleClick={hadleClick}
        orgId={orgId}
        sortDoc={sortDoc}
        sortCode={sortCode}
        sortStartDate={sortStartDate}
        sortName={sortName}
        handleSortDoc={handleSortDoc}
        handleSortCode={handleSortCode}
        handleSortStartDate={handleSortStartDate}
        handleSortName={handleSortName}
        clickedColumn={clickedColumn}
      />

      <div className="pt-3">
        <PaginationControl
          page={page}
          total={totalRows}
          limit={totalLimits}
          totalPage={totalPage}
          changePage={(p) => {
            const body = {
              orgId,
              page: p,
              statusId,
              searchs: bodyFilter.searchs,
              stepId: bodyFilter.stepId ?? '',
              startDateFirst: bodyFilter.startDateFirst ?? '',
              startDateLast: bodyFilter.startDateLast ?? '',
              monthYear,
              order: bodyFilter?.order ?? '',
              sortBy: bodyFilter?.order ?? ''
            }

            getChecklistNew(body)
            setPage(p)
          }}
          ellipsis={1}
        />
      </div>

      <ModalCustom width={630} open={showFilter} onCancel={handleClose}>
        <h4>Filter</h4>
        <Form onSubmit={handleSubmit(onSubmit)} className="mt-3">
          <Row style={{ rowGap: '15px' }}>
            <Col md={12}>
              <LabelCustom text={'Search'} />
              <Controller
                name={'searchs'}
                control={control}
                render={({ field: { onChange, value = '' } }) => (
                  <Form.Control
                    value={value}
                    placeholder="Doc No./ Code/ Name/ Nickname"
                    onChange={onChange}
                    style={{ opacity: 0.7, fontSize: 14 }}
                  />
                )}
              />
            </Col>
            <Col md={6}>
              <LabelCustom text="Step" />
              <Controller
                name={'stepId'}
                control={control}
                render={({ field: { onChange, value = '' } }) => (
                  <Autocomplete
                    isClearable={true}
                    options={optionStep}
                    value={value}
                    onChange={onChange}
                  />
                )}
              />
            </Col>

            <Col md={6}>
              <LabelCustom text="Start date" />
              <Controller
                name={'startDate'}
                control={control}
                render={({ field: { onChange, value = ['', ''] } }) => (
                  <PickerRangeCustom
                    value={value}
                    onChange={(date) => {
                      if (date.length > 1) {
                        const st = fnDateEn(date[0]).format('YYYY-MM-DD')
                        const en = fnDateEn(date[1]).format('YYYY-MM-DD')
                        onChange([st, en])
                      } else if (date.length === 0) {
                        onChange(['', ''])
                      }
                    }}
                  />
                )}
              />
            </Col>

            <Col xl={12} md={12} className="align-self-end text-center mt-4">
              <Button
                style={{ width: '130px' }}
                variant="secondary"
                type="button"
                className=" px-4 bg-white text-secondary me-3"
                onClick={handleClose}
              >
                Cancel
              </Button>
              <Button
                type="submit"
                className=" px-4"
                style={{ width: '130px' }}
              >
                Apply
              </Button>
            </Col>
          </Row>
        </Form>
      </ModalCustom>
    </>
  )
}
